import { creaHtmlPost, createNote } from "~/utils/postUtils";
import Layout from "./Layout";
import TitleLoop from "./TitleLoop";
import CategorieList from "./CategoriesList";
import Badge from "./ArticlePreview/Badge";
import { formatISODateString } from "~/utils/dateFormat";
import PostContent from "./PostContentComponent";
import Link from "next/link";
import Image from "next/image";

const NumberMegazineStampa = ({ articles, numberMagazine }) => {
  const noteForAllArticle = [];
  articles.map((article) => {
    const note = createNote(article);
    noteForAllArticle.push(note != null ? note : []);
  });
  return (
    <>
      <Layout title={numberMagazine}>
        <section className="mx-auto  mb-10 max-w-section px-4 print:max-w-none">
          <div className="mb-12">
            <TitleLoop
              titleLoop={numberMagazine}
              customClass={
                "text-[38px] sm:text-4xl text-[#7b7f86] font-bold uppercase ml-4"
              }
            />
          </div>
          <div className="article is-layout-constrained printContent mx-auto mt-4 max-w-section">
            {articles.map((article, index) => (
              <article key={index} className={`flex w-full flex-col`}>
                <figure>
                  <Link
                    href={`/a/${article.post_name}`}
                    className="flex w-full"
                    prefetch={false}
                  >
                    {article.thumbnail != null && (
                      <Image
                        src={article.thumbnail}
                        width={500}
                        height={400}
                        alt={article?.alt || "immagine di copertina"}
                        className="ml-4 rounded-3xl object-cover print:block print:w-1/3"
                      />
                    )}
                  </Link>
                </figure>
                <div className="entry-header flex flex-col">
                  <header className="px-4">
                    {article?.meta != null && (
                      <CategorieList
                        categories={article?.meta}
                        className="entry-cat text-sm font-medium uppercase tracking-[2px] text-[#90939a] hover:underline print:my-1"
                      />
                    )}
                    {article.meta != null && Boolean(article.meta.autore) && (
                      <span className="author block print:my-2">
                        {`di ${article.meta.autore.replace(/^di /g, "")}`}
                      </span>
                    )}
                    {article.meta != null &&
                      article.meta.sottotitolo?.trim().length > 0 && (
                        <span className="subtitle block print:my-2">
                          {article.meta.sottotitolo}
                        </span>
                      )}
                    <h3 className="mt-1 text-4xl text-[#3b444d] hover:opacity-80 print:my-1">
                      <Link
                        className="entry-title serif print:my-2"
                        href={`/a/${article.post_name}`}
                        dangerouslySetInnerHTML={{ __html: article.post_title }}
                      ></Link>
                    </h3>
                    <Badge meta={article?.meta} />
                  </header>
                  <div className="entry-summary my-2 print:my-2">
                    <p
                      className="!mt-1 px-4"
                      dangerouslySetInnerHTML={{
                        __html: formatISODateString(article.post_date),
                      }}
                    />
                    <PostContent
                      htmlContent={creaHtmlPost(
                        article.post_content,
                        noteForAllArticle[index],
                        `/n/${numberMagazine}/print`
                      )}
                      polls={[]}
                      textStyle={undefined}
                      indexArticle={index}
                    />
                    {noteForAllArticle[index] != null && (
                      <div className="my-8 px-4">
                        <ol>
                          {noteForAllArticle[index].map((nota, index) => (
                            <li className="py-1" key={nota.id} id={nota.id}>
                              <Link
                                href={`/n/${numberMagazine}/print/#${nota.id}-link`}
                                dangerouslySetInnerHTML={{
                                  __html: `${index + 1}. `,
                                }}
                              ></Link>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: `${nota.content}`,
                                }}
                              ></span>
                            </li>
                          ))}
                        </ol>
                      </div>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </Layout>
    </>
  );
};

export default NumberMegazineStampa;
